// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__5mEXL","title":"ClientReferral_title__1-beB","itemText":"ClientReferral_itemText__3kcox"};